import React from 'react';
import { Box, Typography, FormControl, Card, MenuItem, Select, Divider } from '@mui/material';
import { getApolloMedicationAdherence, setApolloMedicationAdherenceStatus } from '../../api';
import useFetch from '../../hooks/useFetch';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

const CoralMedicationAdherence = ({ patientId, username, token }) => {
    const { data: patient, loading, error } = useFetch(getApolloMedicationAdherence, patientId, { username, token});
    const [medications, setMedications] = React.useState([]);

    React.useEffect(() => {
        if (patient && patient.Medications) {
            setMedications(patient.Medications);
        }
    }, [patient]);

    if (loading) return <Typography>Loading...</Typography>;
    if (error) return <Typography>Error: {error.message}</Typography>;

    const handleAckMA = (event, medicationName) => {
        setApolloMedicationAdherenceStatus(patientId, { username, token}, medicationName, 'ACK');
        
        setMedications(prevState => prevState.map(ma =>
            ma.MedicationName === medicationName ? { ...ma, Status: 'ACK' } : ma
        ));
    };

    const handleChangeMA = (event, medicationName) => {
        const { value } = event.target;
        setApolloMedicationAdherenceStatus(patientId, { username, token}, medicationName, value);
        
        setMedications(prevState => prevState.map(ma =>
            ma.MedicationName === medicationName ? { ...ma, Status: value } : ma
        ));
    };

    if (patient.Active === 0) {
        return (<div></div>)
    }

    const maComponent = (
        <>
            {medications.map(ma => {
                let alertColor = "";
                let medStatus = ma.Status;
                if (ma.CoverageStatus === 'covered') {
                    alertColor = "#00AA00"; 
                    medStatus = "current";
                }
                if (ma.CoverageStatus === 'at risk') {
                    alertColor = "#AA44AA";
                    medStatus = "refill due soon";
                } 
                if (ma.CoverageStatus === 'expired') {
                    alertColor = "#FF8C00";
                    medStatus = "need refill";
                }
    
                let statusForm = (
                    <Typography component="span" sx={{ color: alertColor, fontWeight: "bold" }}>
                        {medStatus}
                    </Typography>
                );
                
                let deactivationDate = ma.DeactivationDate;
                let deactivationCode = (<></>);
                if (deactivationDate) {
                    statusForm = (
                        <Typography component="span" sx={{ color: "#555555", fontWeight: "bold" }}>
                        stopped
                    </Typography>
                    );
                    deactivationCode = "Stopped on " + deactivationDate + " by " + ma.DeactivatedBy;
                }
    
                let message = (
                    <>
                        Last Fill Date: {ma.MostRecentFillDate}<br />
                        Coverage End: {ma.CoverageEndDate}<br />
                        {deactivationCode}
                    </>
                );
    
                return (
                    <div key={ma.MedicationName}>
                        <Box
                            display="flex"
                            alignItems="center"
                            justifyContent="space-between"
                            bgcolor="#b8503a"
                            color="white"
                            p={1}
                            borderRadius="4px 4px 0 0"
                        >
                            {ma.MedicationName}
                        </Box>
                        <TableContainer component={Paper}>
                            <Table aria-label="simple table">
                                <TableBody>
                                    <TableRow>
                                        <TableCell sx={{ padding: '4px' }} component="th" scope="row">
                                            {message}
                                        </TableCell>
                                        <TableCell sx={{ padding: '4px' }} align="right">
                                            {statusForm}
                                        </TableCell>
                                    </TableRow>
                                </TableBody>
                            </Table>
                        </TableContainer><Divider sx={{ height:10 }}/>
                    </div>
                );
            })}
        </>
    );
    
    return (
        <div>
            <Accordion defaultExpanded>
                <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                sx={{ backgroundColor: '#d5dbdb', margin: '0 !important', minHeight: 'unset !important', '& .MuiAccordionSummary-content': { margin: '5px 0 !important' } }}
                >
                    <Typography variant="h6">Medication Adherence</Typography>
                </AccordionSummary>
                <AccordionDetails sx={{ backgroundColor: '#eaeded', padding: '12px' }}>
                    {maComponent}
                </AccordionDetails>
            </Accordion>
            <Divider sx={{ height:10 }}/>
        </div>
    );
}

export default CoralMedicationAdherence;
